import React from "react"
import {
  Box, Heading, Stack, Text,
} from "@chakra-ui/react"
import AppDownloadLinks from "components/AppDownloadLinks"
import { LEAD_RETRIEVAL_APP_APPSTORE_LINK, LEAD_RETRIEVAL_APP_PLAYSTORE_LINK, LEAD_RETRIEVAL_HELP_ARTICLE_LINK } from "utilities/externalLinks"
import Link from "components/elements/Link"
import InfoSegment from "../InfoSegment"

type Props = {
  email: string
}

const PaymentSuccessScreen = ({ email }: Props) => (
  <>
    <InfoSegment />
    <Stack spacing={5} textAlign="center">
      <Heading fontWeight="semibold" fontSize="3xl">Your license is activated!</Heading>
      <Box mt={2} mb={8}>
        <Text><b>{email}</b></Text>
      </Box>
      <AppDownloadLinks
        iOSAppURL={LEAD_RETRIEVAL_APP_APPSTORE_LINK}
        AndroidAppURL={LEAD_RETRIEVAL_APP_PLAYSTORE_LINK}
      />
      <Box>
        <Text>Download the app to start scanning leads.</Text>
        <Text>
          For more information, see the
          <Link isExternal href={LEAD_RETRIEVAL_HELP_ARTICLE_LINK}> help article</Link>.
        </Text>
      </Box>
    </Stack>
  </>
)

export default PaymentSuccessScreen
